import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Hero,
  ScrollingText,
  LiveWhereYouWant,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  NeighborhoodSection,
  SocialFeedSection,
  FloorplansList,
  AmenitiesList,
  AmenitiesForYou,
  PhotoGallery,
  NeighborhoodMap,
  NeighborhoodHighlights,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PetPolicyCallout,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  ResidentReview,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
  FAQList,
} from './components';

export const registry: ComponentRegistry = {
  Header,
  Hero,
  ScrollingText,
  LiveWhereYouWant,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  NeighborhoodSection,
  SocialFeedSection,
  FloorplansList,
  AmenitiesList,
  AmenitiesForYou,
  PhotoGallery,
  NeighborhoodMap,
  NeighborhoodHighlights,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PetPolicyCallout,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  ResidentReview,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
  FAQList,
};

export default registry;
